import { useStoredCart } from "./storage.mjs";
import { CART } from "../../const/cookies.mjs";
import { useCookie } from "#imports";
export function clearCart() {
  const { cartState } = useStoredCart();
  cartState.value.cartId = "";
  cartState.value.items = [];
  cartState.value.total = 0;
  cartState.value.subtotal = 0;
  cartState.value.address = void 0;
  cartState.value.shippingFees = void 0;
  cartState.value.itemCount = 0;
}
export function useResetCart() {
  const cartCookies = useCookie(CART);
  function resetCart() {
    clearCart();
    cartCookies.value = null;
  }
  return {
    resetCart
  };
}
